import { render, staticRenderFns } from "./correspondence-popup.vue?vue&type=template&id=038a7bce&scoped=true"
import script from "./correspondence-popup.vue?vue&type=script&lang=js"
export * from "./correspondence-popup.vue?vue&type=script&lang=js"
import style0 from "./correspondence-popup.vue?vue&type=style&index=0&id=038a7bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a7bce",
  null
  
)

export default component.exports